import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { observable, reaction } from 'mobx';
import { Provider } from 'mobx-react';
import { getSnapshot, destroy } from 'mobx-state-tree';
import { connectReduxDevtools } from 'mst-middlewares';
import { onSnapshot } from 'mobx-state-tree';
import registerServiceWorker from './registerServiceWorker';
import createRouter from './config/router';

import LoggedinUser from './models/LoggedinUser';
import { Agent } from './stores/agent';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-social/bootstrap-social.css';
//import 'bootstrap/dist/css/bootstrap-theme.css';
// Put any other imports below so that CSS from your
// components takes precedence over default styles.
//import './index.css'; ////Delete?
import './styles/css/font-awesome.css';
import './styles/css/variables.css';
import './styles/css/reactresponsiveselect.css';
import './styles/css/mypages.css';
import * as ReactGA from 'react-ga';
import App from './components/App';

export let loggedinUser;

const localStorageKey: string = 'loggedinuser';

let initialState = {
  'firstName': '',
  'lastName': '',
  'isauthenticated': false,
  'isRememberMe': false,
  'isLoggingIn': false,
  'isLoading': false,
  'properties':
    {
      'id': '',
      'name': '',
      'email': '',
      'mobilenumber': '',
      'phonenumber': '',
      'extension': '',
      'tenantid': 0,
      'loginname': '',
      'password': '',
      'errors': '',
    },
  'subscriptions':
    {
    },
  'view':
    {
      'page': '',
    },
  'branding':
    {
      'brandingName': '',
      'displayName': '',
      'mainUrl': '',
      'becomeCustomerUrl': '',
      'getSubscriptionUrl': '',
      'fullPhoneNumber': '',
      'displayPhoneNumber': '',
      'mailAddress': '',
    },
};

//Fake data:
let brandingTellit = {
  'brandingName': 'tellit',
  'displayName': 'Tellit', //'Tellit'
  'mainUrl': 'http://tellit.se',
  'becomeCustomerUrl': 'http://tellit.se/hur-fungerar-det',
  'getSubscriptionUrl': 'http://tellit.se/priser',
  'fullPhoneNumber': '+46201202882',
  'displayPhoneNumber': '020-120 28 82',
  'mailAddress': 'kundsupport@tellit.se',
};

let brandingAdvoco = {
  'brandingName': 'advoco',
  'displayName': 'Advoco', //'Advoco'
  'mainUrl': 'http://advoco.se',
  'becomeCustomerUrl': 'http://advoco.se',
  'getSubscriptionUrl': 'http://advoco.se/advoco',
  'fullPhoneNumber': '+46201202920',
  'displayPhoneNumber': '020-120 29 20',
  'mailAddress': 'kundsupport@advoco.se',
};

/*
 * Function to get branding name depending on web site's hostname.
 * 
 *  Values: 'tellit'/ 'advoco' 
*/
export function getBrandingName(): string {
  let brandingName: string = 'tellit'; //default

  let host: string = window.location.host; // 'minasidor.tellit.se'/ 'minasidor.advoco.se'
  //  Others: 'minasidor.netpbx5.net'/ 'localhost:3000'
  if (host.indexOf('localhost') >= 0) {
    // When developing:
    brandingName = 'tellit';   //Alternative1
    //brandingName = 'advoco'; //Alternative2

  } else if (host.indexOf('netpbx5.net') >= 0) {
    if (host.indexOf('advoco') >= 0) {
      //minasidoradvoco.netpbx5.net:
      brandingName = 'advoco';
    } else {
      // minasidor.netpbx5.net:
      brandingName = 'tellit';   //Alternative1
      //brandingName = 'advoco'; //Alternative2     
    }

  } else {
    // In production:
    if (host.indexOf('tellit') >= 0) {
      brandingName = 'tellit';
    } else if (host.indexOf('advoco') >= 0) {
      brandingName = 'advoco';
    } else {
      brandingName = 'advoco';
    }
  }

  return brandingName;

}

/*
* Check if we should be unbranded
* Currently only tellit has a branded mypages
*/
export function getNoBrand(): boolean {
  return (getBrandingName() != 'tellit');
}


/*
 * Function to get My Pages' API root Url depending on host.
 * 
 *  Example: 'https://api_mypages.advoco.se/api'
 *           
*/
export function getAPIRootUrl(): string {
  let APIRootUrl: string = '';

  let host: string = window.location.host; // production: 'minasidor.tellit.se'/ 'minasidor.advoco.se'/ 
  // test: '*.netpbx5.net'(ex betaminasidor.netpbx5.net) / localhost:3000
  if (host.indexOf('localhost') >= 0) {
    // When developing:
    //APIRootUrl = 'https://apinikko.advoco.se/api'; //Alternative1
    APIRootUrl = 'https://betaapinikko.netpbx5.net/api'; //Alternative2

  } else if (host.indexOf('netpbx5.net') >= 0) {
    // both *minasidor.netpbx5.net and *minasidoradvoco.netpbx5.net:
    //APIRootUrl = 'https://apinikko.advoco.se/api'; //Alternative1
    APIRootUrl = 'https://betaapinikko.netpbx5.net/api'; //Alternative2

  } else {
    // In production:     
    if (host.indexOf('tellit') >= 0) {
      APIRootUrl = 'https://apinikko.advoco.se/api';
    } else if (host.indexOf('advoco') >= 0) {
      APIRootUrl = 'https://apinikko.advoco.se/api';
    } else {
      APIRootUrl = 'https://apinikko.advoco.se/api';
    }
  }

  return APIRootUrl;

}

/*
 * Function to get My Pages' Tracking Id in Google Analytics depending on web site's url 
 * 
 *  Example: 'UA-74125180-11' for 'minasidor.tellit.se', 
 *           'UA-74125180-12' for 'minasidor.advoco.se'
 *           
*/
function getGATrackingId(): string {
  let trackingId: string = '';
  let host: string = window.location.host; // 'minasidor.netpbx5.net'/ 'minasidor.tellit.se'
  // Others: 'minasidor.netpbx5.net' / localhost:3000 
  if (host.indexOf('localhost') >= 0) {
    // When developing:
    trackingId = 'UA-74125180-10';  //minasidor.netpbx5.net

  } else if (host.indexOf('netpbx5.net') >= 0) {
    // both minasidor.netpbx5.net and minasidoradvoco.netpbx5.net:
    trackingId = 'UA-74125180-10';  //minasidor.netpbx5.net

  } else {
    // In production:    
    if (host.indexOf('tellit') >= 0) {
      trackingId = 'UA-74125180-11';
    } else if (host.indexOf('advoco') >= 0) {
      trackingId = 'UA-74125180-12';
    } else {
      trackingId = '';
    }

  }

  return trackingId;

}

/*
 * Function to use web site's url to get 'if opened in InApp browser'.
 * Exampel : url like 'minasidor.tellit.se/?browsertype=inapp
 * 
 */
function openedInInAppBrowser(): boolean {
  let inInAppBrowser: boolean = false; //default

  if (window.location.search.length > 0) {
    // url with parameters:

    let parametersArr: string[] = window.location.search.substr(1).split('&');
    for (let par of parametersArr) {
      let currParArr: string[] = par.split('=');
      if (currParArr.length === 2) {
        if (currParArr[0] === ('browsertype') && currParArr[1] === ('inapp')) {
          inInAppBrowser = true;
          break;
        }
      }
    }

  } else {
    // url without parameters:

    inInAppBrowser = false;
  }

  return inInAppBrowser;
}



let snapshotListener;

function createLoggedinUser(snapshot) {
  // clean up snapshot listener
  if (snapshotListener) {
    snapshotListener();
  }
  // kill old store to prevent accidental use and run clean up hooks
  if (loggedinUser) {
    destroy(loggedinUser);
  }

  // create new one
  loggedinUser = LoggedinUser.create(snapshot);

  // connect devtools
  connectReduxDevtools(require('remotedev'), loggedinUser);
  // connect local storage
  snapshotListener = onSnapshot(loggedinUser, snapshot =>
    localStorage.setItem(localStorageKey, JSON.stringify(snapshot))
  );

  return loggedinUser;
}

function renderApp(App, store) {
  ReactDOM.render(
    <Provider loggedinUser={store}>
      <App loggedinUser={store} />
    </Provider>,
    document.getElementById('root')
  );

}

/**
 * Initialization
 */
//Initialize branding:
let appBranding: string = getBrandingName();
// set branding
if (appBranding === 'tellit') {
  initialState.branding = brandingTellit; //fake until setting from server
} else {
  initialState.branding = brandingAdvoco; //fake until setting from server
}
// Get branding texts from server
let agent: Agent = Agent.GetAgent;
agent.GetBrandingText(appBranding);

//Initialize ReactGA (Google Analytics)
// ReactGA.initialize ('UA-74125180-10'); //minasidor.netpbx5.net
let GATrackingId: string = getGATrackingId();
if (GATrackingId !== '') {
  ReactGA.initialize(GATrackingId);
}

// Initial render
renderApp(App, createLoggedinUser(initialState));
registerServiceWorker();

//Initialize 'if opened in InApp Browser'
loggedinUser.view.setInAppMode(openedInInAppBrowser());


// Connect HMR
if (module.hot) {
  module.hot.accept(['./models/LoggedinUser'], () => {
    // Store definition changed, recreate a new one from old state
    renderApp(App, createLoggedinUser(getSnapshot(loggedinUser)));
  });

  module.hot.accept(['./components/App'], () => {
    // Component definition changed, re-render app
    renderApp(App, loggedinUser);
  });
}


/**
 * Routing
 */

reaction(
  () => loggedinUser.view.currentUrl,
  path => {
    '';
    if (window.location.pathname !== path) {
      window.history.pushState(null, '', path);
    }
  }
);

const router = createRouter({
  '/home': loggedinUser.view.openHomePage,
  '/subscriptions': loggedinUser.view.openSubscriptionsPage,
  '/balances': loggedinUser.view.openBalancesPage,
  '/notsubscriber': loggedinUser.view.openNotSubscriberPage,
  '/nodatafound': loggedinUser.view.openNoDataFound,
  '/': loggedinUser.view.openLoginPage
});

window.onpopstate = function historyChange(ev: PopStateEvent) {
  if (ev.type === 'popstate') {
    router(window.location.pathname);
  }
};

router(window.location.pathname);


// WEBPACK FOOTER //
// ./src/index.tsx